import { render, staticRenderFns } from "./BaseButtonSmallWhite.vue?vue&type=template&id=eda38486&scoped=true&"
import script from "./BaseButtonSmallWhite.vue?vue&type=script&lang=js&"
export * from "./BaseButtonSmallWhite.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonSmallWhite.vue?vue&type=style&index=0&id=eda38486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda38486",
  null
  
)

export default component.exports